import {FeedbackChatV2} from 'components/feedback_chat/feeback_chat_v2';
import {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {ANALYTICS_EVENTS, sendTimeSpentEvent} from 'utilities/analytics';

export const FeedbackV2 = () => {
  useEffect(() => {
    const startTime = Date.now();
    return () => {
      const endTime = Date.now();
      const timeSpentSec = (endTime - startTime) / 1000;
      sendTimeSpentEvent(
        ANALYTICS_EVENTS.FEEDBACK_ASSISTANT.TIME_SPENT,
        timeSpentSec,
        'Feedback Assistant'
      );
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Feedback - SPRiTEs-GPT</title>
      </Helmet>
      <FeedbackChatV2 />
    </>
  );
};
